export interface FormatRunSummaryInput {
  projectLabel: string | null;
  batchTypeLabel: string | null;
  modelLabel: string | null;
  promptName: string | null;
}

/**
 * `"Stroke/BJC/WashU March/2026 · Validation · Claude Sonnet 5 · stroke experimental"`.
 * Returns `null` until every part is resolved — the footer falls back to its
 * "Complete all steps to generate" copy until then.
 */
export const formatRunSummary = ({
  projectLabel,
  batchTypeLabel,
  modelLabel,
  promptName,
}: FormatRunSummaryInput): string | null => {
  if (!projectLabel || !batchTypeLabel || !modelLabel || !promptName) {
    return null;
  }

  return [projectLabel, batchTypeLabel, modelLabel, promptName].join(' · ');
};
